export default "__VITE_ASSET__CiagwMnV__"